import { PortalFacilityFaqEntryFragment } from '@/generated/graphql';
import { QuestionAndAnswerCollapse } from '@components/question-and-answer/question-and-answer-collapse';
import { useRouter } from 'next/router';
import { FC, useMemo } from 'react';
import { extractTranslation } from '../../helpers/formatters';

interface FacilityFaqProps {
  facilityFAQEntries: PortalFacilityFaqEntryFragment[];
}

export const FacilityFaq: FC<FacilityFaqProps> = ({ facilityFAQEntries }) => {
  const router = useRouter();

  const facilityQuestionsAndAnswers = useMemo(
    () =>
      facilityFAQEntries
        ?.map((faq) => {
          const question = extractTranslation(faq?.question?.questionText, router.locale);
          const answer = extractTranslation(faq?.answer?.answerText, router.locale);
          if (!!question && !!answer && faq?.id) {
            return {
              question: question,
              answer: answer,
              key: faq?.id,
            };
          } else {
            return undefined;
          }
        })
        ?.filterPresent() || [],
    [facilityFAQEntries, router.locale],
  );

  return (
    <div>
      <QuestionAndAnswerCollapse questionsAndAnswers={facilityQuestionsAndAnswers} />
    </div>
  );
};
